import React from 'react'
import './GoBack.css'

type GoBackProps = {
  onClick?: (e: any) => void
  style?: React.CSSProperties
}

const GoBack: React.FC<GoBackProps> = (props) => {
  return (
    <button
      onClick={props.onClick}
      className={`cocunat-GoBack`}
      style={props.style}
    >
      <img
        src='https://global.cocunat.com/components/go-back-pink.png'
        height='16'
        width='10'
        alt='<'
      />
    </button>
  )
}

export default GoBack
